// extracted by mini-css-extract-plugin
export default {"main":"SurveyCard_main__eNBHM","topContainer":"SurveyCard_topContainer__sBOtu","name":"SurveyCard_name__gd8lA","date":"SurveyCard_date__2D+Hy"};